var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('v-chip',{attrs:{"color":"#" + _vm.dataRow.color,"text-color":"white"}},[_vm._v(_vm._s("#" + _vm.dataRow.color))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }